import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, ConfigProvider, Layout, Typography } from "antd";
import { palette } from "src/theme/liner-shade";
import { FaArrowsAltH } from "react-icons/fa";
import { menuPalette } from "../theme/menu-shade";
import CustomMenu from "./CutomMenu";
import "./Css/Layout.css";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { myTasksStore } from "src/stores/my-tasks-store";

const { Sider } = Layout;
const { Title } = Typography;
const bgSiderStyle = { background: `linear-gradient(to bottom, ${palette.primary}, ${palette.whiteShade}, ${palette.secondary})` };
const bgAppWord = { background: "rgba(255, 255, 255, 0.5)" };

interface SidersProps {}

const SidersComponent: React.FC<SidersProps> = (props) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const profile = profileStore(useShallow((state) => state.profile));
  const getMyTasks = myTasksStore(useShallow((state) => state.getMyTasks));

  const expandSider = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (profile?.activeCompany) {
      getMyTasks();
    }
  }, [profile?.activeCompany]);

  const goHome = () => {
    navigate("/");
  };

  return (
    <Sider
      breakpoint="lg"
      style={bgSiderStyle}
      collapsible
      theme={"light"}
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      trigger={null}
      width={"calc(100vw - 82vw)"}
    >
      <Col>
        <Col className="w-full">
          <div className="w-full h-10 flex flex-row justify-center items-center p-2 mt-3">
            <img className="h-full " src={"/full-logo.png"} alt="" />
          </div>
        </Col>

        <Col className="w-full">
          <div className="w-full h-12 flex flex-row justify-center items-center p-2 mt-3" style={bgAppWord}>
            <Title level={5} className="pt-2">
              VOCs
            </Title>
            <Button size={"small"} className="absolute -right-3 rounded-lg" onClick={expandSider}>
              <FaArrowsAltH />
            </Button>
          </div>
        </Col>
        <Col className="w-full">
          <div onClick={goHome} className={`w-full pl-4 pt-3`}>
            <span className={`text-primaryText cursor-pointer hover:text-slate-950`}>HOME</span>
          </div>
        </Col>

        <ConfigProvider
          theme={{
            token: {
              colorBgContainer: "transparent",
              colorTextBase: menuPalette.primaryText,

              colorPrimaryBg: menuPalette.bgTextActive, // bg active menu
              colorTextDescription: menuPalette.groupSubMenu, // group sub menu color

              colorPrimary: menuPalette.textMenuActive, // color of text active menu
            },
          }}
        >
          <CustomMenu collapsed={collapsed} />
        </ConfigProvider>
      </Col>
    </Sider>
  );
};

export const Siders = SidersComponent;
